<template>
  <div>
    <ValidationObserver ref="observer">
      <b-col>
        <hr />
        <b-row>
          <b-col md="6" style="border-right: 1px solid lightgrey">
            <h4 class="mb-3">Upload ID Proof</h4>
            <b-row>
              <b-col>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="document"
                >
                  <b-form-select
                    v-model="kyc.idType"
                    :options="addressList"
                  ></b-form-select
                  ><span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider></b-col
              >
              <b-col>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="document no."
                >
                  <c-input
                    inputType="text"
                    inputId="idproofNo"
                    lableText="Enter ID Number"
                    v-model="kyc.idproofNo"
                    @input="$emit('readKYC', kyc)"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="6">
                <image-uploader
                  :value="kyc.photoIdFront"
                  @change="(d) => uploadImage('photoIdFront', d)"
                  id="photo ID front-side"
                  text="Upload Front Side"
                ></image-uploader>
                <span v-if="showPhotoIdFront" style="color: red"
                  >Photo is required</span
                >
              </b-col>
              <b-col md="6">
                <image-uploader
                  :value="kyc.photoIdBack"
                  @change="(d) => uploadImage('photoIdBack', d)"
                  id="photo ID back-side"
                  text="Upload Back Side"
                ></image-uploader>
                <span v-if="showPhotoIdBack" style="color: red"
                  >Photo is required</span
                >
              </b-col>
            </b-row>
          </b-col>
          <b-col md="6">
            <h4 class="mb-3">Upload Address Proof</h4>
            <b-row>
              <b-col>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="document"
                >
                  <b-form-select
                    v-model="kyc.addressType"
                    :options="addressList"
                  ></b-form-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </b-col>
              <b-col>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="document no"
                >
                  <c-input
                    inputType="text"
                    inputId="addressproofNo"
                    lableText="Enter ID Number"
                    v-model="kyc.addressproofNo"
                    @input="$emit('readKYC', kyc)"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col md="6">
                <image-uploader
                  :value="kyc.addressProofFront"
                  @change="(d) => uploadImage('addressProofFront', d)"
                  id="address front-side"
                  text="Upload Front Side"
                ></image-uploader>
                <span v-if="showAddressProofFront" style="color: red"
                  >Photo is required</span
                >
              </b-col>
              <b-col md="6">
                <image-uploader
                  :value="kyc.addressProofBack"
                  @change="(d) => uploadImage('addressProofBack', d)"
                  id="address back-side"
                  text="Upload Back Side"
                ></image-uploader>
                <span v-if="showAddressProofBack" style="color: red"
                  >Photo is required</span
                >
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr />
      </b-col>
      <slot name="footer-button" :data="kyc"></slot>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Vue from "vue";
import SingleImage from "../../components/Common/Image.vue";
import ImageUploader from "../../components/FormElements/image.vue";
import cInput from "@/components/FormElements/CustomInput.vue";
export default {
  components: {
    SingleImage,
    cInput,
    ImageUploader,
    ValidationProvider,
    ValidationObserver,
  },
  props: ["kycData"],
  mounted() {
    if (this.kycData && typeof this.kycData === "object") {
      this.kyc = this.kycData;
    }
  },
  data() {
    return {
      kyc: {
        addressProofFront: "",
        addressProofBack: "",
        photoIdFront: "",
        photoIdBack: "",
        idproofNo: "",
        addressproofNo: "",
        addressType: null,
        idType: null,
      },
      isValidating: false,
      addressList: [
        { text: "Select Document Type", value: null, disabled: true },
        { text: "Passport", value: "PASSPORT" },
        { text: "Voter's Identity Card", value: "VOTER_CARD" },
        { text: "Driving Licence", value: "DRIVING_LICENCE" },
        { text: "Aadhaar Card", value: "AADHAR_CARDd" },
      ],
      status: {
        idProofuploaded: false,
        addressProofuploaded: false,
      },
    };
  },
  computed: {
    showPhotoIdFront() {
      if (this.isValidating && !this.kyc.photoIdFront) return true;
    },
    showPhotoIdBack() {
      if (this.isValidating && !this.kyc.photoIdBack) return true;
    },
    showAddressProofFront() {
      if (this.isValidating && !this.kyc.addressProofFront) return true;
    },
    showAddressProofBack() {
      if (this.isValidating && !this.kyc.addressProofBack) return true;
    },
  },
  methods: {
    showCustomToast() {
      Vue.toasted.show("Uploading...", {
        type: "info",
        theme: "toasted-primary",
        singleton: true,
        duration: 1000000,
      });
    },
    isValid() {
      const isValid = this.$refs.observer.validate();
      return isValid;
    },
    handleValidation() {
      this.isValidating = true;
    },
    clearCustomToast() {
      Vue.toasted.clear();
    },
    async uploadImage(path, image) {
      let dataobj = {
        image: image,
        key: (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase(),
        isPublic: true,
        replaceExisting: true,
        basePath: ["kyc", "agent"],
      };
      this.showCustomToast();
      await this.$store
        .dispatch("inventory/uploadImageToStorage", dataobj)
        .then((res) => {
          this.clearCustomToast();
          this.kyc[path] = res.data.fileUrl;
          this.$emit("readKYC", this.kyc);
        })
        .catch((error) => {
          this.clearCustomToast();
          this.$toasted.error("Image not uploaded..please try again!");
        });
    },
    async submitKyc(userId, status) {
      const payload = {
        userId: userId,
        status: status,
        documents: [
          {
            category: "ID_PROOF",
            docType: this.kyc.idType,
            docuementNo: this.kyc.idproofNo,
            frontSideFilePath: this.kyc.photoIdFront,
            backSideFilePath: this.kyc.photoIdBack,
          },
          {
            category: "ADDRESS_PROOF",
            docType: this.kyc.addressType,
            docuementNo: this.kyc.addressproofNo,
            frontSideFilePath: this.kyc.addressProofFront,
            backSideFilePath: this.kyc.addressProofBack,
          },
        ],
      };
      try {
        await this.$store.dispatch("tenant/submitKYCByTenant", payload);
        this.showAlert("Success", "Success", "KYC Submitted For Tenant");
      } catch (e) {
        this.showAlert("Error", "Error", "Error Submitting Kyc");
      }
      return;
    },
    showAlert(type, title, text) {
      this.$swal({
        title,
        text,
        type,
      });
    },
  },
};
</script>
<style scoped>
[btn-color="primary"] {
  height: 41px;
  background-color: var(--primary);
  font-weight: 600;
  font-size: medium;
  letter-spacing: 2px;
  font-family: "Lato";
  color: white;
  border: 0px;
  border-radius: 0px;
}

[btn-special="primary"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: "Lato";
  border-radius: 0px;
  height: 43px;
  width: 139px;
  background-color: var(--primary);
  color: white;
}
</style>
